import ptBr from "./pt-BR";
import enUs from "./en-US";

export default {
  "pt-BR": ptBr,
  "en-US": enUs
};
